"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
const SessionUtils_1 = require("./SessionUtils");
const SessionDefinition_1 = require("../SessionDefinition");
const Attendee_1 = require("./Attendee");
var LocalVideoDevice;
(function (LocalVideoDevice) {
    LocalVideoDevice["None"] = "None";
    LocalVideoDevice["RearCamera"] = "RearCamera";
    LocalVideoDevice["FrontCamera"] = "FrontCamera";
})(LocalVideoDevice = exports.LocalVideoDevice || (exports.LocalVideoDevice = {}));
var ResourceProvidingOption;
(function (ResourceProvidingOption) {
    ResourceProvidingOption["AsDefault"] = "AsDefault";
    ResourceProvidingOption["Provide"] = "Provide";
    ResourceProvidingOption["NotProvide"] = "NotProvide";
})(ResourceProvidingOption = exports.ResourceProvidingOption || (exports.ResourceProvidingOption = {}));
class SessionStateChanged {
    constructor(st, msg) {
        this.SessionTicket = st;
        this.RelatedMessage = TypeScriptUtils_1.isNullOrEmpty(msg) ? '' : msg;
    }
}
exports.SessionStateChanged = SessionStateChanged;
class SessionTicket {
    constructor(si) {
        this.id = "";
        this.version = 0;
        this.type = SessionDefinition_1.SessionType.Unknown;
        this.creator = Attendee_1.Creator.Nobody;
        this.fileName = "";
        this.needRecord = false;
        this.localDefaultVideoDevice = LocalVideoDevice.None;
        this.localScreenWidth = 0;
        this.localScreenHeight = 0;
        this.createdFrom = 0;
        this._provideLocalAudio = ResourceProvidingOption.AsDefault;
        if (si) {
            this.id = si.id || this.id;
            this.version = 0;
            this.type = si.type || this.type;
            this.creator = new Attendee_1.Creator(si.creator) || this.creator;
            this.fileName = si.fileName || this.fileName;
            this.needRecord = si.needRecord || this.needRecord;
            this.localDefaultVideoDevice = si.localDefaultVideoDevice || this.localDefaultVideoDevice;
            this.localScreenWidth = si.localScreenWidth || this.localScreenWidth;
            this.localScreenHeight = si.localScreenHeight || this.localScreenHeight;
            this._provideLocalAudio = si.ResourceProvidingOption || this._provideLocalAudio;
            this.createdFrom = Date.now();
        }
    }
    get ResourceProvidingOption() { return this._provideLocalAudio; }
    isMultiMedia() {
        return this.type === SessionDefinition_1.SessionType.Video
            || this.type === SessionDefinition_1.SessionType.Audio
            || this.type === SessionDefinition_1.SessionType.RemoteVideoAudioOnly
            || this.type === SessionDefinition_1.SessionType.LocalVideoAudioOnly
            || this.type === SessionDefinition_1.SessionType.SharingScreen
            || this.type === SessionDefinition_1.SessionType.VideoLive
            || this.type === SessionDefinition_1.SessionType.AudioLive;
    }
    isValid() {
        return !TypeScriptUtils_1.isNullOrEmpty(this.id) && (this !== SessionTicket.UNKNOWN_SESSION_TICKET);
    }
    toString() {
        return JSON.stringify(this);
    }
    static GenerateSessionId() {
        return SessionUtils_1.SessionUtils.GenerateId();
    }
    static Builder(si) {
        return new SessionTicketBuilder(si);
    }
}
SessionTicket.UNKNOWN_SESSION_ID = "";
SessionTicket.UNKNOWN_SESSION_TICKET = new SessionTicket({
    id: SessionTicket.UNKNOWN_SESSION_ID,
    type: SessionDefinition_1.SessionType.Unknown
});
SessionTicket.INVALID_SCREEN_LENGTH = -1;
exports.SessionTicket = SessionTicket;
class SessionTicketBuilder {
    constructor(st) {
        this.id = "";
        this.version = 0;
        this.type = SessionDefinition_1.SessionType.Unknown;
        this.creator = Attendee_1.Creator.Nobody;
        this.fileName = "";
        this.needRecord = false;
        this.localDefaultVideoDevice = LocalVideoDevice.None;
        this.localScreenWidth = SessionTicket.INVALID_SCREEN_LENGTH;
        this.localScreenHeight = SessionTicket.INVALID_SCREEN_LENGTH;
        this.createdFrom = 0;
        if (st) {
            this.id = st.id || this.id;
            this.version = st.version || this.version;
            this.type = st.type || this.type;
            this.creator = st.creator || this.creator;
            this.fileName = st.fileName || this.fileName;
            this.needRecord = st.needRecord || this.needRecord;
            this.localDefaultVideoDevice = st.localDefaultVideoDevice || this.localDefaultVideoDevice;
            this.localScreenWidth = st.localScreenWidth || this.localScreenWidth;
            this.localScreenHeight = st.localScreenHeight || this.localScreenHeight;
            this.createdFrom = Date.now();
        }
    }
    Id(id) {
        this.id = id;
        return this;
    }
    AutoId() {
        this.id = SessionUtils_1.SessionUtils.GenerateId();
        return this;
    }
    Type(st) {
        this.type = st;
        return this;
    }
    Creator(creator) {
        this.creator = creator;
        return this;
    }
    // public Creator(id: string, name: string): SessionTicketBuilder
    // {
    //     this.creator = new Creator(id, name);
    //     return this;
    // }
    CreatorName(creatorName) {
        this.creator = new Attendee_1.Creator({ id: "", name: creatorName });
        return this;
    }
    FileName(fileName) {
        this.fileName = fileName;
        return this;
    }
    NeedRecord(nr) {
        this.needRecord = nr;
        return this;
    }
    DefaultLocalVideoDevice(lvd) {
        this.localDefaultVideoDevice = lvd;
        return this;
    }
    LocalScreenWidth(width) {
        this.localScreenWidth = width;
        return this;
    }
    LocalScreenHeight(height) {
        this.localScreenHeight = height;
        return this;
    }
    Build() {
        this.createdFrom = Date.now();
        return new SessionTicket({
            id: this.id,
            version: this.version,
            type: this.type,
            creator: this.creator,
            fileName: this.fileName,
            needRecord: this.needRecord,
            localDefaultVideoDevice: this.localDefaultVideoDevice,
            localScreenWidth: this.localScreenWidth,
            localScreenHeight: this.localScreenHeight,
            createdFrom: this.createdFrom,
        });
    }
}
exports.SessionTicketBuilder = SessionTicketBuilder;
//# sourceMappingURL=SessionTicket.js.map